import { totalDistance, twoOptOptimize } from "../lib/opt/twoOpt";

// 2-opt 는 후보마다 전체 거리를 다시 재서 셀 수의 세제곱으로 느려진다.
// 이보다 많으면 지그재그 순서를 그대로 쓴다. 격자에서는 지그재그가 이미 거의 최단이다.
const TWO_OPT_MAX_CELLS = 60;

/** 지그재그 정렬: row 오름차순, 짝수 행 col 오름차순, 홀수 행 col 내림차순. */
export function serpentineIds(ids, gridCells) {
  const cellMap = new Map((gridCells || []).map((cell) => [cell.id, cell]));
  return [...(ids || [])].sort((a, b) => {
    const ca = cellMap.get(a);
    const cb = cellMap.get(b);
    if (!ca || !cb) return 0;
    if (ca.row !== cb.row) return ca.row - cb.row;
    return ca.row % 2 === 0 ? ca.col - cb.col : cb.col - ca.col;
  });
}

/**
 * 드론이 실제로 도는 셀 순서. 업로드와 화면(지도 경로 선, 미션 박스 순번)이 모두 이 함수를 쓴다.
 * 지그재그로 줄 세운 뒤 셀이 적으면 2-opt 로 다듬는다. 중심 좌표가 없는 셀은 빠진다.
 */
export function flightOrder(ids, gridCells) {
  const cellMap = new Map((gridCells || []).map((cell) => [cell.id, cell]));
  const coords = serpentineIds(ids, gridCells)
    .map((id) => {
      const center = cellMap.get(id)?.center;
      if (!center) return null;
      return { id, lat: Number(center.latitude), lng: Number(center.longitude), alt: 0 };
    })
    .filter(Boolean);
  if (coords.length < 3 || coords.length > TWO_OPT_MAX_CELLS) return coords.map((c) => c.id);
  return twoOptOptimize(coords, totalDistance, { fixStart: false, fixEnd: false }).map((c) => c.id);
}
